import { z } from "zod/v4";

import { BillingNormalizedIntentV1Schema } from "./intents";
import {
  BillingPlanExecutionDispositionSchema,
  BillingPlanIntentRefV1Schema,
  BillingPlanIntentStateSchema,
  ShopifyMoneyV1Schema,
} from "./plan-intent-ref";

export const BillingPlanIntentDesiredPlanV1Schema = z.object({
  schemaVersion: z.literal("v1"),
  normalizedIntent: BillingNormalizedIntentV1Schema,
});

export type BillingPlanIntentDesiredPlanV1 = z.infer<
  typeof BillingPlanIntentDesiredPlanV1Schema
>;

export const BillingPlanIntentSnapshotV1Schema = z.object({
  ...BillingPlanIntentRefV1Schema.shape,
  appliedRevision: z.number().int().positive().nullable(),
  state: BillingPlanIntentStateSchema,
  executionDisposition: BillingPlanExecutionDispositionSchema,
  desiredPlan: BillingPlanIntentDesiredPlanV1Schema,
  requiredShopifyCap: ShopifyMoneyV1Schema.nullish(),
});

export type BillingPlanIntentSnapshotV1 = z.infer<
  typeof BillingPlanIntentSnapshotV1Schema
>;
